import { SelectionRef } from '@/feature/bet-share-sbk/utils/resolve-selections';
import { Bet } from '@/feature/bets-sbk/hooks/types';
import { BetSocialLinkType, CreateLinkResponse, createSocialLink } from '@/feature/entry-share/utils/social-link';
import { useUserStore } from '@/hooks/use-user-store';

export const getBetSelectionRefs = (bet: Bet): SelectionRef[] =>
    bet.events.flatMap(event =>
        event.selections.map(selection => ({
            event_id: event.id,
            market_id: selection.market.id,
            option_id: selection.option.id,
        }))
    );

export const createSbkShareLink = async (
    bet: Bet,
    meta: { title: string; desc: string },
    type: BetSocialLinkType
): Promise<CreateLinkResponse> => {
    const { profile } = useUserStore.getState();
    const link = await createSocialLink({
        payload: { entryId: bet.id, selections: getBetSelectionRefs(bet) },
        type,
        user_id: profile.sub,
        user_email: profile.email,
        meta,
    });
    // the link service returns error bodies without throwing; no shortUrl means it failed
    if (!link?.shortUrl) {
        throw new Error('Share link creation failed');
    }
    return link;
};
